module.exports = "/images/searchIcon.svg";